"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchString = void 0;
var react_1 = require("react");
var useSearchString = function (_a) {
    var 
    // showOptions,
    searchStringInParent = _a.searchStringInParent, setSearchStringInParent = _a.setSearchStringInParent;
    var _b = (0, react_1.useState)(searchStringInParent || ""), searchString = _b[0], _setSearchString = _b[1];
    var setSearchString = function (string) {
        _setSearchString(string);
        setSearchStringInParent && setSearchStringInParent(string);
    };
    // useEffect(() => {
    //   if(searchStringInParent !== searchString){
    //   }
    // }, [searchStringInParent]); /**if value is changed from outside the dropdown by the parent, then search string needs to be updated */
    return [searchString, setSearchString];
};
exports.useSearchString = useSearchString;
